import { css } from '@microsoft/fast-element';
export const AnchoredRegionStyles = css `
  :host {
    contain: layout;
    display: block;
  }
`;
